// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"9f5414f1","98":"e46b99a8","142":"a8ef38d9","225":"57dac333","321":"77db4681","453":"60b7ceda","523":"97655821","568":"8029fa0e","598":"a3abccf1","654":"52495037","704":"c669b825"}[chunkId] + ".chunk.js";
};